import { render, staticRenderFns } from "./TransactionTable.vue?vue&type=template&id=3fe8f43c&scoped=true"
import script from "./TransactionTable.vue?vue&type=script&lang=ts"
export * from "./TransactionTable.vue?vue&type=script&lang=ts"
import style0 from "./TransactionTable.vue?vue&type=style&index=0&id=3fe8f43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe8f43c",
  null
  
)

export default component.exports